<template>
  <div class="bg-blue-1 common-padding-top">
    <div class="bottom-border common-padding-bottom">
      <div class="div-center common-body-width container">
        <div class="font-12 color-white common-padding-bottom-1 common-line-height-2-5">
          <span>合作机构：</span>
          <a target="_blank" class="color-white common-margin-left-1" href="https://pay.weixin.qq.com/">微信</a>
          <a target="_blank" class="color-white common-margin-left-1" href="https://www.alipay.com/">支付宝</a>
          <a target="_blank" class="color-white common-margin-left-1" href="http://cn.unionpay.com/">银联商务</a>
          <a target="_blank" class="color-white common-margin-left-1" href="https://open.duolabao.com">京东</a>
          <a target="_blank" class="color-white common-margin-left-1" href="http://cn.unionpay.com/">云闪付</a>
          <a target="_blank" class="color-white common-margin-left-1" href="http://www.ccb.com/">建设银行</a>
        </div>
        <div class="font-14 color-white common-margin-top">
          <span>
            <span><img class="common-img-icon-xs" :src="require('images/home/addr.png')" /></span>
            <span class="common-padding-left-0-5">广州天河区林和西路167号威尼国际写字楼2833-2836室</span>
          </span>
          <span class="common-margin-left-2">
            <span><img class="common-img-icon-xs" :src="require('images/home/email.png')" /></span>
            <span class="common-padding-left-0-5">wangtao@yindiankeji.com</span>
          </span>
          <span class="common-margin-left-2">
            <span><img class="common-img-icon-xs" :src="require('images/home/tel.png')" /></span>
            <span class="common-padding-left-0-5"><a class="color-white" href="tel://4000-468-365">4000-468-365</a></span>
          </span>
        </div>
      </div>
    </div>
    <div class="font-14 common-padding text-center color-white">
      © 2020-2030 yunfastpay.com, all rights reserved &nbsp;&nbsp;<a class="color-white" href="http://beian.miit.gov.cn/">粤ICP备17017897号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommHeader'
}
</script>



// WEBPACK FOOTER //
// src/components/CommFooter.vue